<template>
  <crud-form
    v-model="payload"
    :total-group="2"
    :request-class="requestClass"
    page-title="Adicionar integrador"
    navigate-back-route="contacard.integrador.list"
    navigate-page-after-save="contacard.integrador.list"
    :override-create-payload="overrideCreatePayload"
    :override-edit-payload="overrideEditPayload"
    :override-set-entity-data="overrideSetEntityData"
  >
    <template slot="group-1">
      <integrador-content v-model="payload">
        <v-row>
          <v-col
            v-if="payload.id"
            cols="6"
          >
            <input-text
              id="input:id"
              v-model="payload.id"
              label="Código"
              disabled
            />
          </v-col>
        </v-row>
      </integrador-content>
    </template>
    <template
      v-if="getIntegradorId"
      slot="group-2"
    >
      <form-group>
        <v-row>
          <v-col>
            <div class="d-flex align-center justify-start pa-8">
              <h1 class="h1Header secondary300">
                Produtos
              </h1>
            </div>
          </v-col>
        </v-row>
        <produto-integrador-list />
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from '@/app/arch/components/crud/CrudForm.vue';
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import RulesMixin from '@/app/arch/mixins/RulesMixin';
import IntegradorRequest from 'Modules/contacard/produto/integrador/IntegradorRequest';
import NotificationMixin from '@/app/arch/mixins/NotificationMixin';
import ProdutoRequest from 'Modules/contacard/produto/product/ProdutoRequest';
import ProdutoIntegradorList from 'Modules/contacard/produto/integrador/ProdutoIntegradorList.vue';
import IntegradorContent from './IntegradorContent.vue';

export default
{
  name: 'IntegradorForm',
  components: {
    CrudForm,
    FormGroup,
    ProdutoIntegradorList,
    IntegradorContent,
  },
  mixins: [RulesMixin, NotificationMixin],
  data: () => ({
    requestClass: IntegradorRequest,
    requestProduto: ProdutoRequest,
    loading: null,
    payload: {
      nomIntegrador: '',
      sglIntegrador: '',
    },
    produtoId: '',
    produtoIdOptions: [],
  }),
  computed: {
    getIntegradorId() {
      return this.$route.params.id || this.payload.id;
    },
  },
  beforeMount() {
    this.makeAuxRequest();
  },
  methods: {
    makeAuxRequest() {
      this.makeProdutoRequest();
    },
    makeProdutoRequest() {
      this.requestProduto.list({
        page: 1,
        PerPage: 1000,
      }).then(({ data }) => {
        this.setProdutoDataOptions(data.data);
      }).catch(({ response }) => {
        this.setProdutoMessageError(response.data.message);
      });
    },
    setProdutoDataOptions(data) {
      this.produtoIdOptions = data.map((item) => ({
        value: item.id,
        text: item.nomProdutoServico,
      }));
    },
    setProdutoMessageError(message) {
      this.showMessageError(
        message || 'Falha ao buscar produtos',
      );
    },
    showMessageError(message) {
      this.showErrorToast({
        text: message,
      });
    },
    makeSaveProdutoRequest() {
      this.requestClass.addProduto(
        this.getIntegradorId,
        this.produtoId,
        {
          codIntegrador: this.getIntegradorId,
        },
      )
        .then(() => {
          this.showSuccessToast({
            text: 'Produto salvo com sucesso!',
          });
        })
        .catch(({ response }) => {
          this.setSaveProdutoMessageError(response.data.message);
        }).finally(() => {
          this.loading = false;
        });
    },
    setSaveProdutoMessageError(message) {
      this.showMessageError(
        message || 'Falha em salvar produto',
      );
    },
    saveProdutoIntegrador() {
      this.loading = true;
      this.makeSaveProdutoRequest();
    },
    overrideSetEntityData(data) {
      return { ...data };
    },
    overrideCreatePayload() {
      return { ...this.payload };
    },
    overrideEditPayload() {
      return { ...this.payload };
    },
  },
};
</script>
